export const API_URL =
  process.env?.REACT_APP_API_URL ?? "https://d-api.9and9.supercharged.dev/api/";
